import { Number, Record, Static, String } from 'runtypes'
export const ShipAddress = Record({
    id: Number,
    address: String
})

export type IShipAddress = Static<typeof ShipAddress>
